import { Action, getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { ForgotPasswordMetaData } from 'types/forgot-password';
import { getForgotPasswordMetaData } from '@api/forgot-password';
import store from '..';

@Module({
	dynamic: true,
	namespaced: true,
	name: 'resetPassword',
	store
})
class ResetPasswordModule extends VuexModule {
	dataRetrieved = false;
	passwordResetKey = '';
	passwordResetSessionUuid = '';
	forgotPasswordMetaData: ForgotPasswordMetaData | null = null;

	@Action({ rawError: true })
	public async initiateResetPasswordFlow(): Promise<void> {
		const forgotPasswordFlow = await getForgotPasswordMetaData();
		this.UPDATE_DATA_RETRIEVED(true);
		this.UPDATE_FORGOT_PASSWORD_METADATA(forgotPasswordFlow);
	}

	@Mutation
	public UPDATE_DATA_RETRIEVED(dataRetrieved: boolean): void {
		this.dataRetrieved = dataRetrieved;
	}

	@Mutation
	public UPDATE_FORGOT_PASSWORD_METADATA(forgotPasswordMetaData: ForgotPasswordMetaData): void {
		this.forgotPasswordMetaData = forgotPasswordMetaData;
	}

	@Mutation
	public UPDATE_PASSWORD_RESET_KEY(passwordResetKey: string): void {
		this.passwordResetKey = passwordResetKey;
	}

	@Mutation
	public UPDATE_PASSWORD_RESET_SESSION_UUID(passwordResetSessionUuid: string): void {
		this.passwordResetSessionUuid = passwordResetSessionUuid;
	}
}

export const resetPassword = getModule(ResetPasswordModule);
